export const api = {
  productSearch: '/products-search',
  productLessById: '/product-details',
  campaignLocationListing: '/country/relation',
  teamBonusRanksList: '/team-bonus-ranks-list',
  enrollmentRanksList: '/enrollment-ranks-list',
  campaignListing: '/campaign-list',
  campaign: '/campaign',
  esacVoucherTypeListing: '/esac-voucher-type-list',
  esacVoucherType: '/esac-voucher-type',
  esacVoucherSubTypeListing: '/esac-voucher-sub-type-list',
  esacVoucherSubType: '/esac-voucher-sub-type',
  esacPromotionListing: '/esac-promotion-list',
  esacPromotion: '/esac-promotion',
  esacVoucherListing: '/esac-voucher-list',
  esacVoucher: '/esac-voucher',
  esacRedemptionListing: '/sales-list',
  paymentModesWithMonetaryValue: '/payments/monetary-value-providers',
}
